import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappbilleterabody} from './/bodyappbilleterabody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './/withRouter'
class Bodyappbilletera extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappbilleterabody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappbilletera);